import component from './saved-cards.component';
import routes from './saved-cards.routes';

export default angular
  .module('fizyweb.paycell.savedcards', [])
  .component('fizyPaycellSavedCards', component)
  .config(routes).name;



// WEBPACK FOOTER //
// src/app/buy/saved-cards/saved-cards.module.ts